const FaqData = [
  {
    id: 1,
    title: 'What services does Scoolj Institute offer?',
    info: 'We provide four core services: Education & Training (digital skills, professional development), Business Expansion & Market Entry (African market strategy), Marketing & Brand Development, and Technology & Software Development through our subsidiary Scoolj Lab.',
  },
  {
    id: 2,
    title: 'Who can benefit from your services?',
    info: 'Our services cater to individuals seeking skills development, SMEs looking to expand, international companies entering African markets, educational institutions, startups needing technology solutions, and organizations requiring digital transformation.',
  },
  {
    id: 3,
    title: 'What makes Scoolj Lab different from other tech companies?',
    info: 'Scoolj Lab combines technical expertise with deep understanding of African markets and user behavior. We focus on building scalable, user-friendly solutions that solve real business problems with end-to-end support from concept to deployment.',
  },
  {
    id: 4,
    title: 'How do you approach business expansion projects?',
    info: 'We provide comprehensive market research, cultural intelligence, regulatory guidance, and go-to-market strategies. Our approach includes feasibility studies, consumer insights, and hands-on execution support for successful market entry.',
  },
  {
    id: 5,
    title: 'What is included in your training programs?',
    info: 'Our training programs are practical and industry-aligned, covering digital skills, professional development, management consulting, and curriculum development. We focus on delivering measurable results and real-world applications.',
  },
  {
    id: 6,
    title: 'How can I get started with a project?',
    info: 'Contact us through our website form, email (info@scooljinstitute.com), or phone (+234 703 475 6746). We\'ll schedule a consultation to understand your needs and provide a customized solution proposal.',
  },
  {
    id: 7,
    title: 'What are your typical project timelines?',
    info: 'Project timelines vary based on scope and complexity. Training programs can range from weeks to months, while technology projects typically take 2-6 months. We provide detailed timelines during our initial consultation.',
  },
  {
    id: 8,
    title: 'Do you provide ongoing support after project completion?',
    info: 'Yes, we believe in long-term client success. We provide ongoing support, maintenance, and consultation as needed. Our goal is to ensure sustained value and growth from our solutions.',
  },
]

export default FaqData;